import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import HeaderCartModal from './HeaderCartModal';
import { useAppDispatch, useAppSelector } from '../../services/hooks';
import HeaderAccountModalLogged from './HeaderAccountModalLogged';
import HeaderAccountModalGuest from './HeaderAccountModalGuest';
import { setModalShow } from '../../stores/user/userSlice';
import { useTranslation } from 'react-i18next';

export default function HeaderModals() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const user = useAppSelector((state) => state.user.email);
    const logged = useAppSelector((state) => state.user.logged);
    const [show, setShow] = useState(false);
    const products = useAppSelector((state) => state.cart.products);

    function handleShow(show: boolean) {
        setShow(show);
    }
    console.log('logged: ', logged)
    return (
        <Nav>
            <Nav.Item>
                {logged
                    ? (<Button variant='success' onClick={() => dispatch(setModalShow(true))}
                        className='bi bi-person-circle rounded-2 text-truncate d-none d-xl-inline-block'
                        style={{ width: "200px" }}>
                        <small>
                            &nbsp;{user}
                        </small>
                    </Button>)
                    : (<Button
                        onClick={() => dispatch(setModalShow(true))}
                        className="rounded-2 bi bi-person-circle text-truncate button-user-modal d-none d-xl-inline-block text-white bg-secondary"
                        style={{ width: "200px" }}
                    >
                        <small>
                            &nbsp;{t('header.modal.account.login')}
                        </small>
                    </Button>)
                }
            </Nav.Item>
            <Nav.Item id="cartIcon">
                <Button variant='success' data-testid="cart_modal_button" onClick={() => handleShow(true)}
                    className='bi bi-cart rounded-2 position-relative ms-xl-3'>
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-1 bg-black small p-1">
                        <small className="cart-products-count">{Array.isArray(products) ? products.length : 0}</small>
                        <span className="visually-hidden">Items in cart</span>
                    </span>
                </Button>
            </Nav.Item>
            {logged
                ? <HeaderAccountModalLogged />
                : <HeaderAccountModalGuest />
            }
            <HeaderCartModal show={show} onHide={() => handleShow(false)} />
        </Nav>
    )
}